module.exports = __webpack_public_path__ + "logo_alt-6090911445f54a587465e41da77a6969.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/logo_alt.svg
// module id = 266
// module chunks = 76